export enum UserManagementElementType {
  'ORGANISATION' = 'ORGANISATION',
  'TEAM' = 'TEAM',
  'TENANT' = 'TENANT',
}
